import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { useThemeTokens } from '../../../utils/themeTokens';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className="bg-slate-800 text-white dark:text-slate-50 px-3 py-2 rounded-lg shadow-lg text-xs">
      <p className="font-semibold mb-1">{label}</p>
      {payload.map((entry, i) => (
        <p key={i} className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: entry.color }} />
          {entry.name}: {entry.value.toLocaleString(undefined, { maximumFractionDigits: 1 })} t
        </p>
      ))}
    </div>
  );
};

const DailyActivityChart = ({ data }) => {
  const t = useThemeTokens();

  if (!data || data.length === 0) {
    return (
      <div className="bg-surface rounded-xl border border-slate-200 shadow-sm p-6 text-center">
        <p className="text-sm text-slate-400">No daily activity data</p>
      </div>
    );
  }

  const chartData = data.map((d) => ({
    date: new Date(d.date).toLocaleDateString('en-ZA', { month: 'short', day: 'numeric' }),
    Dispatch: d.dispatchTonnage,
    Receipt: d.receiptTonnage,
  }));

  return (
    <div className="bg-surface rounded-xl border border-slate-200 shadow-sm">
      <div className="px-5 py-4 border-b border-slate-100">
        <h3 className="text-base font-semibold text-slate-800">Daily Activity</h3>
        <p className="text-xs text-slate-400 mt-0.5">
          {data.length} active day{data.length !== 1 ? 's' : ''} in range
        </p>
      </div>

      <div className="px-3 py-3">
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={chartData} margin={{ top: 5, right: 5, left: -15, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={t.grid} />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 10, fill: t.axisLabel }}
              tickLine={false}
              axisLine={{ stroke: t.grid }}
              interval="preserveStartEnd"
            />
            <YAxis
              tick={{ fontSize: 10, fill: t.axisLabel }}
              tickLine={false}
              axisLine={false}
              tickFormatter={(v) => (v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v)}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend iconSize={8} wrapperStyle={{ fontSize: 11, paddingTop: 4 }} />
            <Bar dataKey="Dispatch" fill="#45B7AA" radius={[2, 2, 0, 0]} maxBarSize={20} />
            <Bar dataKey="Receipt" fill="#10b981" radius={[2, 2, 0, 0]} maxBarSize={20} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DailyActivityChart;
